<header>
    <!-- <img src="./assets/login-header.jpg" style="width: 100%;"> -->
    <div class="row">
        <div class="col-md-12" style="padding: 0;" style="background-image: url('./../../../assets/bg.png');background-repeat: no-repeat;background-size: cover;">
            <img src="./../../../assets/Logo2.png" alt="Dental Council of India" title="Dental Council of India">
            <!-- <a href="https://rashtragaan.in/">         
                <img src="./../../../assets/Logo75.png" class="tabView" alt="Dental Council of India" title="Dental Council of India">
            </a>
            <img src="./../../../assets/logoembdig.png" alt="Dental Council of India" title="Dental Council of India"> -->
        <img src="./../../../assets/Digital_India_logo.png" alt="Dental Council of India" title="Dental Council of India"
            style="position: absolute; top: 10px; right: 20px; height: 70px;">
        </div>
    </div>
    <div class="container-fluid mt-4">
        <div class="row">
            <div class="col-md-6">
                <h5 class="headingValue">Register</h5>
            </div>
            <div class="col-md-6 text-right">
                <button type="button" class="btn btn-primary clearBtn" routerLink="../login">Back</button>            </div>
        </div>
        <hr>
    </div>
</header>
<div class="row">
    <div class="col-md-1">&nbsp;</div>
    <div class="col-md-10" style="background: #eee;
    padding: 10px;">
        <div class="row">
            <div class="col-xl-6 col-lg-6">
                <div class="card l-bg-cherry">
                    <div class="card-statistic-3 p-4">
                        <div class="card-icon card-icon-large"><i class="fas fa-school"></i></div>
                        <div class="mb-4">
                            <h3 class="card-title mb-0">College</h3>
                        </div>
                        <div class="row align-items-center mb-2 d-flex">
                            <div class="col-8" routerLink="/allregister/register/college" style="cursor: pointer;">
                                <h5 class="d-flex align-items-center mb-0">
                                    Register Now
                                </h5>
                            </div>
                            <div class="col-4 text-right" routerLink="/allregister/register/college" style="cursor: pointer;">
                                <i class="fa fa-arrow-right"></i>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div class="col-xl-6 col-lg-6">
                <div class="card l-bg-blue-dark">
                    <div class="card-statistic-3 p-4">
                        <div class="card-icon card-icon-large"><i class="fas fa-users"></i></div>
                        <div class="mb-4">
                            <h3 class="card-title mb-0">Complaint</h3>
                        </div>
                        <div class="row align-items-center mb-2 d-flex">
                            <div class="col-8">
                                <h5 class="d-flex align-items-center mb-0" style="cursor: pointer;" routerLink="../allregister/complaint">
                                     Register Now
                                </h5>
                            </div>
                            <div class="col-4 text-right" routerLink="/allregister/register/complaint">
                                <i class="fa fa-arrow-right" style="cursor: pointer;"></i>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
              <div class="col-xl-6 col-lg-6">
                <div class="card l-bg-blue-dark">
                    <div class="card-statistic-3 p-4">
                        <div class="card-icon card-icon-large"><i class="fas fa-users"></i></div>
                        <div class="mb-4">
                            <h3 class="card-title mb-0">Student</h3>
                        </div>
                        <div class="row align-items-center mb-2 d-flex">
                            <div class="col-8">
                                <h5 class="d-flex align-items-center mb-0" style="cursor: pointer;">
                                     Register Now
                                </h5>
                            </div>
                            <div class="col-4 text-right">
                                <i class="fa fa-arrow-right" style="cursor: pointer;"></i>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div class="col-xl-6 col-lg-6">
                <div class="card l-bg-blue-dark">
                    <div class="card-statistic-3 p-4">
                        <div class="card-icon card-icon-large"><i class="fas fa-users"></i></div>
                        <div class="mb-4">
                            <h3 class="card-title mb-0">New College</h3>
                        </div>
                        <div class="row align-items-center mb-2 d-flex">
                            <div class="col-8">
                                <h5 class="d-flex align-items-center mb-0" style="cursor: pointer;" routerLink="../allregister/register/ug-registration">
                                     Register Now
                                </h5>
                            </div>
                            <div class="col-4 text-right" routerLink="../allregister/register/ug-registration">
                                <i class="fa fa-arrow-right" style="cursor: pointer;"></i>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>